import { Container, Sprite, TextStyle, Text, FederatedPointerEvent } from "pixi.js";
import { HourlyBonusResourcePackage } from "../../resources/HourlyBonusResourcePackage";
import { ButtonWithScaleAndPosYAnimation } from "../../../../../common/components/ButtonWithScaleAndPosYAnimation";
import { IFortuneWheelModel } from "../../../model/IFortuneWheelModel";
import { GameFont } from "../../../../../common/GameFont";
import { IGoldenWheelModel } from "../../../model/IGoldenWheelModel";
import { SpinButtonState } from "./SpinButtonState";
import { Event } from "event-system";

export class GoldenWheelSpinButton extends Container {
    private static readonly BUY_TEXT = "BUY FOR\n$";
    private static readonly PAYMENT_PROCESS = "PAYMENT\nPROCESS...";
    private static readonly SPIN_NOW = "SPIN\nNOW";

    public get onSpinClicked(): Event<ButtonWithScaleAndPosYAnimation, FederatedPointerEvent> {
        return this.spinButton.onUp;
    }

    private readonly wheelResources: HourlyBonusResourcePackage;
    private readonly goldenWheelModel: IGoldenWheelModel;
    private spinButtonBg: Sprite;
    private spinButtonLight: Sprite;
    private spinButton: ButtonWithScaleAndPosYAnimation;
    private spinButtonText: Text;

    public constructor(
        wheelResources: HourlyBonusResourcePackage,
        fortuneWheelModel: IFortuneWheelModel
    ) {
        super();
        this.wheelResources = wheelResources;
        this.goldenWheelModel = fortuneWheelModel.goldenWheelModel.value;
        this.build();
    }

    private build(): void {
        this.spinButtonBg = new Sprite(this.wheelResources.assets_views_hourly_bonus_button_bg_png);
        this.spinButtonBg.anchor.set(0.5, 0.5);
        this.spinButtonBg.position.y = 50;
        this.addChild(this.spinButtonBg);
        this.spinButtonLight = new Sprite(this.wheelResources.assets_views_hourly_bonus_golden_wheel_wheel_button_light_png);
        this.spinButtonLight.anchor.set(0.5, 0.5);
        this.spinButtonLight.position.y = 10
        this.addChild(this.spinButtonLight);
        this.spinButton = new ButtonWithScaleAndPosYAnimation(this.wheelResources.assets_views_hourly_bonus_golden_wheel_wheel_button_red_png);
        this.spinButton.position.set(-this.spinButton.width * 0.5, -this.spinButton.height * 0.5 + 10);
        this.addChild(this.spinButton);
        const spinText = this.goldenWheelModel.isPaid.value ? GoldenWheelSpinButton.SPIN_NOW : `${GoldenWheelSpinButton.BUY_TEXT}${this.goldenWheelModel.price.value}`;
        this.spinButtonText = new Text(spinText, new SpinButtonTextStyle());
        this.spinButtonText.position.set(this.spinButton.width * 0.5 - this.spinButtonText.width * 0.5, this.spinButton.height * 0.5 - this.spinButtonText.height * 0.5);
        this.spinButton.addChild(this.spinButtonText);
    }

    public updateFromPaymentStatus(state: SpinButtonState): void {
        switch (state) {
            case SpinButtonState.SPIN_NOW:
                this.spinButton.defaultView.texture = this.wheelResources.assets_views_hourly_bonus_golden_wheel_wheel_button_red_png;
                this.spinButtonText.text = GoldenWheelSpinButton.SPIN_NOW;
                break;
            case SpinButtonState.PROCESS:
                this.spinButton.defaultView.texture = this.wheelResources.assets_views_hourly_bonus_golden_wheel_wheel_button_gray_png;
                this.spinButtonText.text = GoldenWheelSpinButton.PAYMENT_PROCESS;
                break;
            case SpinButtonState.FAILURE:
                this.spinButton.defaultView.texture = this.wheelResources.assets_views_hourly_bonus_golden_wheel_wheel_button_red_png;
                this.spinButtonText.text = `${GoldenWheelSpinButton.BUY_TEXT}${this.goldenWheelModel.price.value}`
                break;
        }
        this.spinButtonText.position.set(this.spinButton.width * 0.5 - this.spinButtonText.width * 0.5, this.spinButton.height * 0.5 - this.spinButtonText.height * 0.5);
    }
}

class SpinButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 62,
            leading: 10
        }));
    }
}
